import { StorageActionTypes } from '~/actions/waterStorage';
import { SessionProfileActionTypes } from '~/actions/session';
import { convertWaterLv2Storage } from '~/utils/waterStorage';

const initialState = {
  site_id: '',
  minSeaLv: 0,
  maxSeaLv: 0,
  startTime: 0,
  history: [],
};

export default (state = initialState, action) => {
  const { type, ...param } = action;

  // `action.type`
  switch (type) {
    case SessionProfileActionTypes.LOAD:
      const {
        profile: {
          pressure: { site_id, min_sea_water, max_sea_water },
        },
      } = param;
      return {
        ...state,
        site_id,
        minSeaLv: min_sea_water,
        maxSeaLv: max_sea_water,
      };
    case StorageActionTypes.LOAD_WATER_STORAGE:
      if (Object.prototype.hasOwnProperty.call(param, 'data')) {
        const { data, startTime } = param;
        const { site_id, minSeaLv, maxSeaLv } = state;
        return {
          ...state,
          startTime,
          history: data.map((item) => {
            const currentWaterLv =
              item.value < minSeaLv ? minSeaLv : item.value > maxSeaLv ? maxSeaLv : item.value;
            return {
              ...item,
              original: currentWaterLv,
              value: convertWaterLv2Storage(site_id, currentWaterLv),
            };
          }),
        };
      }
      return state;
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./resources/assets/js/reducers/waterStorage.js